import 'reflect-metadata';
import '@quandis/qbo4.ui';
import { html as litHtml, css } from 'lit';
export { html, css } from 'lit';
export * from './IConfiguration.js';
export * from './Configuration.js';
export * from './qbo-config-editor.js';
export * from './qbo-template.js';
export * from './qbo-css.js';
export function redefineCustomElements() {
    // Store the original customElements.define method
    const originalDefine = window.customElements.define;
    // Override customElements.define
    window.customElements.define = function (tagName, elementClass, options) {
        if (!window.customElements.get(tagName))
            originalDefine.call(this, tagName, elementClass, options);
        else
            console.error(`Custom element ${tagName} already defined`);
    };
}
window.qbo4 = window.qbo4 || {}; // Ensure qbo4 exists
window.qbo4["configuration"] = {
    templates: (Map),
    html: litHtml,
    css: css
};
//# sourceMappingURL=Program.js.map